import React from 'react'
import PropTypes from 'prop-types'
import classes from './styles.module.scss'
import { FormattedMessage, injectIntl } from 'react-intl'
import messages from './messages'
import { InputItem } from 'antd-mobile'
import Countdown from 'react-countdown-now'
import { checkFormError } from 'utils'

class SMSCode extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      counting: true,
      date: Date.now()
    }
  }

  renderer = ({ seconds, completed }) => {
    if (completed) {
      return (
        <span className={classes.sendBtn} onClick={this.handleSendSMS}>
          <FormattedMessage {...messages.getCode} />
        </span>
      )
    } else {
      return <span className={classes.sendBtn}>{seconds} s</span>
    }
  }

  handleSendSMS = () => {
    const { form, required, getSMS } = this.props
    form.validateFields(
      [...required],
      (error, value) => {
        if (checkFormError(error)) {
          getSMS(value, () =>
            this.setState({
              date: Date.now() + 59000,
            })
          )
        }
      }
    )
  }

  render() {
    const { form, intl, name, onFocus, placeholder } = this.props
    return (
      <div className={classes.componentsSmsCode}>
        {form.getFieldDecorator(name, {
          rules: [
            {
              type: 'string',
              required: true,
              len: 6,
              message: intl.formatMessage(messages.errorMsg),
            },
          ],
        })(
          <InputItem
            type='tel'
            maxLength={6}
            onFocus={onFocus}
            placeholder={placeholder || intl.formatMessage(messages.placeholder)}
            extra={
              <Countdown
                key={this.state.date}
                date={this.state.date}
                renderer={this.renderer}
              />
            }
          />
        )}
      </div>
    )
  }
}

export default injectIntl(SMSCode)

SMSCode.propTypes = {
  form: PropTypes.object.isRequired
}
